//
//
//
//
//
//
//

import Search from './Search'
import Tables from './Table'
import UpdateDialog from './Update'
import Model from '@/models/create'
import { mapGetters,mapActions } from "vuex";
export default {
    components:{
        Search,Tables,UpdateDialog
    },
    data(){
        return{
            layerId:'',
            submitState: false,
            searchData:{
                carno:'',
                state:'',
                startDiscount:'',
                endDiscount:''
            },
            pageConfig:{
                current:1,
                pageSize:10
            }
        }
    },
    computed:{
        ...mapGetters('create',{
            list:'getTable',
            detail:'getDetail',
            total:'getTotal'
        })
    },
    methods:{
        ...mapActions('user',{
            setUserBalance:'setUserBalanceAction'
        }),
        ...mapActions('create',{
            setTableAction:'setTableAction',
            setCarNoListAction: 'setCarNoListAction',
            setDetailAction:'setDetailAction',
            emptyDetailAction:'emptyDetailAction',
            setParkListAction: 'setParkListAction'
        }),
        async addDiscount(){
            if(this.submitState) return;
            this.submitState = true;
            let {data} = await Model.addDiscount(this.detail);
            this.submitState = false;
            if(data.success){
                this.setTableAction(this.searchData)
                this.setUserBalance(data.list)
                this.updateForm()
            }
        },
        async canelDiscount(params){
            let {data} = await Model.canelDiscount({discountno:params.discountId});
            if(data.success){
                this.setTableAction(this.searchData)
            }
        },
        async updateDiscount(params){
            if(this.submitState) return;
            this.submitState = true;
            let {data} = await Model.updateDiscount(this.detail);
            this.submitState = false;
            if(data.success){
                this.setTableAction(this.searchData)
                this.setUserBalance(data.list)
                this.updateForm()
            }
        },
        addDis(){
            this.emptyDetailAction();
            this.updateForm();
        },
        updateDis(id){
            this.setDetailAction(id);
            this.updateForm();
        },
        updateForm(){
            this.$refs.updateDialog.visible = !this.$refs.updateDialog.visible;
        }
    },
    created(){
        this.setTableAction()
        this.setParkListAction()
    },
    destroyed(){
        this.$layer.close(this.layerId)
    }
}



// WEBPACK FOOTER //
// ./src/pages/create/view.vue